import { Box, Divider, Modal } from '@mui/material';

import ModalStyle from '@/constants/ModalStyle';
import useSwitchChild from '@/hooks/useSwitchChild';

/**
 * Stay vs clear-and-switch when the cart has lines for another child.
 */
export default function SwitchChildConfirm() {
	const {
		pendingSwitchCustomerId,
		children,
		confirmClearAndSwitch,
		cancelPendingSwitch,
		switchingLocked,
	} = useSwitchChild();

	const open = pendingSwitchCustomerId != null;
	const target = children.find((c) => Number(c.id) === Number(pendingSwitchCustomerId));
	const targetName = target?.member?.name || 'this student';

	return (
		<Modal
			open={open}
			onClose={() => {
				if (!switchingLocked) cancelPendingSwitch();
			}}
			aria-labelledby='switch-child-title'
			aria-describedby='switch-child-desc'
			className='w-full'
		>
			<Box sx={{ ...ModalStyle, top: '25%' }} className='flex w-[90%] flex-col gap-4 md:w-[360px]'>
				<h2 id='switch-child-title' className='text-center text-md font-bold text-black'>
					Switch student?
				</h2>
				<Divider />
				<p id='switch-child-desc' className='text-center text-sm text-black'>
					Your cart has items for another student. Stay to keep them, or clear the cart and order for{' '}
					<span className='font-bold'>{targetName}</span>.
				</p>
				<Divider />
				<div className='ml-auto flex gap-2'>
					<button
						type='button'
						className='btn-actions min-w-max border border-black bg-white text-black'
						onClick={() => cancelPendingSwitch()}
						disabled={switchingLocked}
					>
						Stay
					</button>
					<button
						type='button'
						className='btn-actions min-w-max bg-black'
						onClick={() => confirmClearAndSwitch()}
						disabled={switchingLocked}
					>
						Clear and switch
					</button>
				</div>
			</Box>
		</Modal>
	);
}
